import ReCAPTCHA from "react-google-recaptcha"
import React, { useRef, useState } from 'react'
import axios from 'axios'
import { API_BASE_URL, RECAPTCHA_KEY } from "config"
import { Alert, Container, Row, Col } from 'react-bootstrap';
import ProgressBar from 'react-bootstrap/ProgressBar';
import styles from './authorization.module.css';

export default function Authorization(props) {
    const sessionId = props.sessionId
    const captchaRef = useRef(null)
    const [accessCode, setAccessCode] = useState(props.defaultAccessCode)
    const [errorMessage, setErrorMessage] = useState('')
    const [loading, setLoading] = useState(false)
    const genericError = "Unknown error has occurred, please try again.";

    const handleSubmit = async (e) => {
        setLoading(true)
        setErrorMessage('')
        try {
            e.preventDefault();
            const captchaToken = await captchaRef.current.executeAsync()
            captchaRef.current.reset()
            const response = await axios.post(`${API_BASE_URL}/sessions/viewing/authenticate`,
                {
                    sessionId: sessionId,
                    accessCode: accessCode,
                    captchaToken: captchaToken
                })
            switch (response.status) {
                case 200:
                    props.onAuthorization(response.data.accessToken)
                    break
                default:
                    setErrorMessage(genericError)
                    setLoading(false)
            }
        } catch (ex) {
            if (ex?.response?.status === 400) {
                setErrorMessage(ex.response.data.errorMessage)
            } else {
                setErrorMessage(genericError)
            }
            setLoading(false)
        }
    }

    return (
        <>
            <div className={styles.child}>
                <div className={styles.accessCodeEntry}>
                    {!loading &&
                        <form onSubmit={handleSubmit}>
                            <div className="input-group">
                                <input id="txt-access-code" type="text" className={`form-control ${styles.accessCode}`} placeholder="Access Code" value={accessCode} onChange={e => setAccessCode(e.target.value)} />
                                <span className="input-group-btn">
                                    <button id="btn-validate" className={`btn btn-success ${styles.goButton}`} type="submit">Go!</button>
                                </span>
                            </div>
                        </form>
                    }
                    {errorMessage != '' &&
                        <Container>
                            <Row className="mt-3">
                                <Alert variant="danger">
                                    {errorMessage}
                                </Alert>
                            </Row>
                        </Container>
                    }
                    {loading &&
                        <Container>
                            <Row>
                                <Col>
                                    <ProgressBar variant="success" animated now={100} />
                                </Col>
                            </Row>
                        </Container>
                    }
                </div>
            </div>
            <ReCAPTCHA size="invisible" sitekey={RECAPTCHA_KEY} ref={captchaRef} />
        </>
    )
}